const CTX_CLICK_OUTSIDE = 'CTX_CLICK_OUTSIDE'

const clickListener = (el, event, binding) => {
  const path = event.composedPath()
  const isClickoutside = path ? path.indexOf(el) < 0 : !el.contains(event.target)

  if (!isClickoutside) return
  binding.value(event)
}

const ClickOutsideDirective = {
  mounted(el, binding) {
    el[CTX_CLICK_OUTSIDE] = e => clickListener(el, e, binding)
    setTimeout(() => {
      document.addEventListener('click', el[CTX_CLICK_OUTSIDE])
    }, 0)
  },
  
  unmounted(el) {
    if (el[CTX_CLICK_OUTSIDE]) {
      document.removeEventListener('click', el[CTX_CLICK_OUTSIDE])
      delete el[CTX_CLICK_OUTSIDE]
    }
  },
}

export default ClickOutsideDirective